import { EfectivizarPrestamoMS } from 'src/app/open-api';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pago-prestamo-invoice',
  templateUrl: './pago-prestamo-invoice.component.html',
  styleUrls: ['./pago-prestamo-invoice.component.scss']
})
export class PagoPrestamoInvoiceComponent implements OnInit {

  @Input() comprobante?: EfectivizarPrestamoMS;
  fecha = new Date().toLocaleDateString();
  constructor() { }

  ngOnInit(): void {
  }

}
